var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rounded-lg overflow-hidden",attrs:{"id":"p1s2c2"}},[_c('canvas',{staticClass:"p-10",attrs:{"id":"chartPie"}})])
}]

export { render, staticRenderFns }